import type { ModuloWeb } from '../../nucleo/modulos-web';
import { AbaAparencia, AbaEmpresa } from './AbaEmpresa';
import { AtalhoCrm } from './AtalhoCrm';
import { Campos, CriarCampo } from './Campos';
import { CamposTelas } from './CamposTelas';
import { Estruturas } from './Estruturas';
import { Modelos } from './Modelos';
import { ModosOperacao } from './ModosOperacao';
import { Sequencias } from './Sequencias';
import { AbaSubsistemas } from './AbaSubsistemas';
import { Visoes } from './Visoes';
import { i18n } from './i18n';

const modulo: ModuloWeb = {
  slug: 'configuracoes',
  menu: 'admin',
  ordem: 20,
  abas: [
    { chave: 'empresa', permissao: 'configuracoes.ver', componente: AbaEmpresa },
    { chave: 'aparencia', permissao: 'configuracoes.ver', componente: AbaAparencia },
    // Fase 2 (W8): modo de operação por módulo (GET e PUT /configuracoes/modos exigem configuracoes.editar).
    { chave: 'modos', permissao: 'configuracoes.editar', componente: ModosOperacao },
    // D1 (sub-sistemas, L3): onde cada página aparece, por workspace e por empresa (GET e PUT /configuracoes/subsistemas, permissão do núcleo).
    { chave: 'subsistemas', permissao: 'nucleo.subsistemas.configurar', componente: AbaSubsistemas },
    { chave: 'sequencias', permissao: 'configuracoes.ver', componente: Sequencias },
    { chave: 'campos', permissao: 'configuracoes.ver', componente: Campos },
    // Lote de 19/10 (item 9): campos nativos de cada tela de cadastro (GET e PUT /configuracoes/campos-telas).
    { chave: 'campos-telas', permissao: 'configuracoes.campos_telas', componente: CamposTelas },
    { chave: 'visoes', permissao: 'configuracoes.ver', componente: Visoes },
    { chave: 'modelos', permissao: 'configuracoes.ver', componente: Modelos },
    { chave: 'estruturas', permissao: 'configuracoes.ver', componente: Estruturas },
    // Rodada crm1 (SPEC-M2): entrada das Configurações do CRM (a página fica no CRM; a permissão só existe com o Pipeline).
    { chave: 'crm', permissao: 'pipeline.configurar', componente: AtalhoCrm },
  ],
  i18n,
  // Lote crm7: a lista de campos de uma entidade, para as Configurações do CRM (Configurar campos de cadastro).
  camposPorEntidade: Campos,
  criarCampo: CriarCampo,
};

export default modulo;
